import { Button, Stack, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { com } from '@eidu/form'
import { Download } from '@mui/icons-material'
import EntityFieldDisplayGroup from '../shared/EntityFieldDisplayGroup'
import PageLayout from '../shared/PageLayout'
import { KindViewPageProps } from '../KindPages'
import useHasPermission from '../../../permission/useHasPermission'
import getResourceUrl from '../../../../io/api/resource/getResourceUrl'
import { getResourceKeyFromEntity } from '../../../../io/entityResourceKeyLink'
import EntityAction = com.eidu.sharedlib.entity.permission.EntityAction

const RuntimeViewPage = ({ entity, entityType, fields }: KindViewPageProps) => {
  const navigate = useNavigate()

  const { hasPermission: hasUpdatePermission } = useHasPermission(entity.entity.id, EntityAction.UpdateEntity)

  const navigateToEdit = () => {
    navigate(`/entities/${entityType.id.toString()}/edit/${entity.entity.id.toString()}`)
  }

  const resourceKey = getResourceKeyFromEntity(entity)
  const resourceUrl = resourceKey ? getResourceUrl(resourceKey) : undefined

  return (
    <PageLayout
      title={entity.primaryLabelText}
      subtitle={entityType.name}
      actions={hasUpdatePermission ? <Button onClick={navigateToEdit}>Edit</Button> : undefined}
      showBack
    >
      <EntityFieldDisplayGroup entityType={entityType} fields={fields} />
      {resourceUrl && (
        <Stack spacing={1} sx={{ mt: 2 }}>
          <Typography variant="subtitle2">Payload</Typography>
          <Button
            variant="outlined"
            startIcon={<Download />}
            href={resourceUrl}
            download
            sx={{ alignSelf: 'flex-start' }}
          >
            Download
          </Button>
        </Stack>
      )}
    </PageLayout>
  )
}

export default RuntimeViewPage
